var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export const ShiftDetailsTableContext = React.createContext({
    missionId: undefined,
    defaultRowsPerPage: 5,
    onSendMessageToVolunteers: () => { },
});
export const ShiftDetailsTableContextProvider = (_a) => {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    return (React.createElement(ShiftDetailsTableContext.Provider, { value: Object.assign({}, restProps) }, children));
};
